module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "TOC.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('p', {
    staticClass: "TOCtitle"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('a', {
    attrs: {
      "href": "#/On_a_Winters_Eve#Anchor-1"
    }
  }, [_vm._v("ON A WINTER’S EVE by Louise Allen")])]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('span', {
    attrs: {
      "href": "#/Marriage_Made_at_Christmas_of_book_2#Anchor-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MARRIAGE MADE AT CHRISTMAS by Sophia James")])]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('span', {
    attrs: {
      "href": "#/Cinderellas_Perfect_Christmas_of_book_3#Anchor-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CINDERELLA’S PERFECT CHRISTMAS by Annie Burrows")])]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('span', {
    attrs: {
      "href": "#/Excerpt_of_book_3#Anchor-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excerpt from "), _c('em', [_vm._v("Unwrapping the Rancher’s Secret")]), _vm._v(" by Lauri Robinson")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8f28ebe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TOC.vue
// module id = 72
// module chunks = 0